export default function () {
  return {
    order_fulfillment_version: null,
    order_keeps_fulfillment_controls: false
  }
}
